import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { getEmployeeList } from "src/apis/employeeApi";
import { getItemPopupList } from "src/apis/itemApi";
import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { KioskSwitchButtonForm } from "src/components/common/form/KioskSwitchButtonForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig, InfoFieldHandlers } from "src/types/info-form";
import { formatDate, formatDateWithTime } from "src/utils/string/stringUtil";
import { KSK2021_R01HeaderDto, KSK2021_R01WorkTimeProcessType } from "./Dto_KSK2021_R01";
import { InputForm_KSK2021_R01 } from "./InputForm_KSK2021_R01";
import { useKSK2021_R01Store } from "./Store_KSK2021_R01";



interface Props {
	editable: boolean

	defaultKSK2021_R01HeaderRow: KSK2021_R01HeaderDto;
	handleWorkTimeClick: (productWorkNo: string, processType: KSK2021_R01WorkTimeProcessType, manualTime?: Date) => Promise<boolean>;

	handleFetchBomProductList: (productWorkNo: string, itemCd: string, warehouseCd: string, logicCenter: string ) => void;
	handleFetchLotList: (onFail?: () => void) => void;

	getProductWorkFieldHandlers: (fieldName: string) => InfoFieldHandlers;
	validateWorkStartEnd: (time: string | undefined) => boolean;
}

export const Info_KSK2021_R01 = (props: Props) => {

	const { editable, 
		defaultKSK2021_R01HeaderRow,
		handleWorkTimeClick,
		handleFetchBomProductList, handleFetchLotList,
		getProductWorkFieldHandlers,
		validateWorkStartEnd,
	} = props;

	// const { companyList } = useCompanyStore();
	const { itemStatusList, jobTeamList, wmsCdList, compCdList, employeeCdList, workPlaceList, warehouseCdList,  } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { 
			KSK2021_R01Filter, setKSK2021_R01Filter,
			editKSK2021_R01, setEditKSK2021_R01,
			isInitialLoad, setIsInitialLoad,
			modalVisible, setModalVisible,
	} = useKSK2021_R01Store();

	// 매출일자 달력 팝업 상태
	const [productDtPickerVisible, setProductDtPickerVisible] = useState(false);
	const [productDtPickerPos, setProductDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});


	const workEmpInfoHandleFoucsId = 'infoWorkEmpInput';
	const [searchTrigger, setSearchTrigger] = useState(false);

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
            category: "품목",
            focusId: "itemCd_search",
			responseMapping: {
				itemCd : 'itemCd',
				itemNm : 'itemNm',
				itemSpec : 'itemSpec',
				itemUnit : 'itemUnit'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getItemPopupList(code, '', '', '');
				return employeeResponse.data.data.find(value => value.itemCd === code);
			}
        },
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: workEmpInfoHandleFoucsId,
			responseMapping: {
				empNo: 'workEmp',
				empNm: 'workEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		},
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK2021_R01,
		setEditData: setEditKSK2021_R01,
		defaultData: defaultKSK2021_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2021_R01'
	});

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		// 초기 로드 시에는 Content에서 이미 호출했으므로 건너뜁니다.
		if (isInitialLoad) {
			setIsInitialLoad(false);
			return;
		}

		if(editKSK2021_R01?.productWorkNo && editKSK2021_R01?.itemCd && editKSK2021_R01?.outWarehouseCd && editKSK2021_R01?.logicCenter) {
			handleFetchBomProductList(
				editKSK2021_R01.productWorkNo,
				editKSK2021_R01.itemCd,
				editKSK2021_R01.outWarehouseCd,
				editKSK2021_R01.logicCenter
			);
		}
	}, [
		editKSK2021_R01?.productWorkNo,
		editKSK2021_R01?.itemCd,
		editKSK2021_R01?.outWarehouseCd,
		editKSK2021_R01?.logicCenter
	])

	useEffect(() => {
		if (searchTrigger) {
			handleFetchLotList();
			setSearchTrigger(false);
		}
	}, [searchTrigger]);

	const handleDateChange = useCallback((field: keyof KSK2021_R01HeaderDto, value: any) => {
		setEditKSK2021_R01({
			...defaultKSK2021_R01HeaderRow,
			...editKSK2021_R01,
			[field]: value
		});
	}, [editKSK2021_R01, defaultKSK2021_R01HeaderRow, setEditKSK2021_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		let closeTag = editKSK2021_R01?.closeTag || 'N';
		if(Number(editKSK2021_R01?.orderQty) === Number(editKSK2021_R01?.productQty)) {
			closeTag = 'Y';
		}else {
			closeTag = 'N';
		}

		//상태값이 바뀌면 closeTag 갱신
		setEditKSK2021_R01({
			...defaultKSK2021_R01HeaderRow,
			...editKSK2021_R01,
			[name]: name === 'productQty' || name === 'badQty' ? Number(value) : value,
			closeTag: closeTag
		});
	}, [editKSK2021_R01, defaultKSK2021_R01HeaderRow, setEditKSK2021_R01]);


	return (
		<div className="w-full h-full flex gap-[4px] pt-[12px] pl-[12px] pr-[12px]" ref={containerRef}>
			<div
				className="flex-1 min-w-0 h-full max-h-full flex flex-wrap content-start overflow-y-auto"
				ref={infoRef}
			>
				<InputForm_KSK2021_R01 
					setSearchTrigger={setSearchTrigger}
					handleChange={handleChange} 
					handleFetchLotList={handleFetchLotList} 
					getProductWorkFieldHandlers={getProductWorkFieldHandlers}
				/>
				<BRDiv />
				<DropDownForm
					title="작업정보"
					name="workplaceCd"
					initLabelLess={true}
					value={editKSK2021_R01?.workplaceCd}
					data={workPlaceList}
					editable={false}
					onChange={handleChange}
				/>
				<SingleDateForm
					title="생산일자"
					value={editKSK2021_R01?.productDt ? new Date(editKSK2021_R01.productDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('productDt', formatDate(value))}
					editable={false}
					visible={productDtPickerVisible} setVisible={setProductDtPickerVisible}
					onChange={handleChange}
					pickerPos={productDtPickerPos} setPickerPos={setProductDtPickerPos}
				/>
				<BRDiv />
				<CodeForm
					label="품목코드"
					value={editKSK2021_R01?.itemCd || ""}
					custNmValue={editKSK2021_R01?.itemNm || ""}
					editable={false}
					name="itemCd"
					handleChange={() => { }}
					onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
					onKeyDown={() => { }}
					wrapperOption = {{
						wrapperStyle: "w-[700px] min-w-[700px] mr-[10px] mb-[5px]",
						titleStyle: "w-[150px] min-w-[150px] text-left",
						codeInputStyle: "w-[200px] min-w-[200px]",
						custNmInputStyle: "w-[355px] min-w-[355px]"
					}}
				/>
				<BRDiv />
				<InputForm title="규격" value={editKSK2021_R01?.itemSpec || ""}
					editable={false}
					name="itemSpec"
					onChange={handleChange} />
				<InputForm title="단위" value={editKSK2021_R01?.itemUnit || ""}
					editable={false}
					name="itemUnit"
					onChange={handleChange} />
				<BRDiv />
				<InputForm title="작업지시잔량" value={editKSK2021_R01?.orderQty || 0}
					editable={false}
					name="orderQty"
					onChange={handleChange} />
				<InputForm title="생산완료량" value={editKSK2021_R01?.resultQty || 0}
					editable={false}
					name="resultQty"
					onChange={handleChange} />
				<BRDiv />
				<InputForm title="생산양품량" value={editKSK2021_R01?.productQty || 0}
					editable={true}
					name="productQty"
					onChange={handleChange} />
				<BRDiv />
				<DropDownForm
					title="작업팀"
					name="jobTeam"
					initLabelLess={true}
					value={editKSK2021_R01?.jobTeam}
					data={jobTeamList}
					editable={true}
					onChange={handleChange}
				/>
				<DropDownForm
					title="등급"
					name="itemStatus"
					initLabelLess={true}
					value={editKSK2021_R01?.itemStatus}
					data={itemStatusList}
					editable={true}
					onChange={handleChange}
				/>
				<BRDiv />
				<CodeForm
					label="작업자"
					value={editKSK2021_R01?.workEmp || ""}
					custNmValue={editKSK2021_R01?.workEmpNm || ""}
					editable={true}
					name="workEmp"
					handleChange={handleChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<BRDiv />
				<div className="w-full flex justify-start shrink-0 mb-[5px]" style={{ height: '50px' }}>
					<button 
						type="button"
						className="relative h-full w-[205px] bg-blue-dark hover:bg-gray-400 text-white text-[18px] py-[1px] mr-[6px] rounded-[4px]"
						onClick={() => handleWorkTimeClick(editKSK2021_R01?.productWorkNo || '', 'workStart')}
					>
						작업시작
						{!validateWorkStartEnd(editKSK2021_R01?.fromTime || undefined) ? <br /> : ''}
						{!validateWorkStartEnd(editKSK2021_R01?.fromTime || undefined) ? formatDateWithTime(editKSK2021_R01?.fromTime || undefined) : ''}
					</button>
					<button 
						type="button"
						className="relative h-full w-[205px] bg-blue-dark hover:bg-gray-400 text-white text-[18px] py-[1px] rounded-[4px]"
						onClick={() => handleWorkTimeClick(editKSK2021_R01?.productWorkNo || '', 'workEnd')}
					>
						작업종료
						{!validateWorkStartEnd(editKSK2021_R01?.toTime || undefined) ? <br /> : ''}
						{!validateWorkStartEnd(editKSK2021_R01?.toTime || undefined) ? formatDateWithTime(editKSK2021_R01?.toTime || undefined) : ''}
					</button>
				</div>
			</div>

			<div className="w-[400px] shrink-0 h-full flex flex-col content-start gap-[8px] pt-[4px] pl-[12px] border-l border-gray-300">
				<InputForm title="생산불량수량" value={editKSK2021_R01?.badQty || 0}
					editable={false}
					name="badQty"
					onChange={handleChange} />
				<KioskSwitchButtonForm
					title="라벨자동출력"
					name="labelPrintAuto"
					value={KSK2021_R01Filter.labelPrintAuto as 'Y' | 'N'}
					onChange={(name, value) => setKSK2021_R01Filter({ ...KSK2021_R01Filter, [name]: value })}
				/>
				<button
					type="button"
					className="relative w-[150px] bg-blue-dark text-white text-[18px] py-[1px] rounded-[4px] h-[30px]"
					onClick={() => setModalVisible(!modalVisible)}
				>
					불량내역
				</button>
			</div>
		</div>
	)
}
